module.exports = __webpack_public_path__ + "img/shape_avatar.cbcb8370.svg";